module.exports = __webpack_public_path__ + "static/img/1_1_4.6b48ce7d.jpg";